import React from "react";
import CustomDataTable from "../../components/CustomDataTable/CustomDataTable";
import { ENDPOINT } from "../../services/endPoints";
import { useOutlet } from "react-router-dom";

const PatientList = () => {
  const outlet = useOutlet();
  const excludedKeys = [
    "id",
    "updatedAt",
    "patient_middle_name",
    "phone_number",
    "zip_code",
    "deletedAt",
    "createdAt",
    "question1",
    "question2",
    "question3",
    "education_level",
    "occupation",
    "country_of_origin",
    "disability",
    "permanent_residential_address",
    "inkhundla",
    "chiefdom",
    "current_residential_address",
    "postal_address",
    "primary_cellphone",
    "secondary_cellphone",
    "land_phone",
    "patient_email_id",
    "CMIS_id",
    "patient_code",
    "year",
    "nurse_id",
    "nurse_name",
    "marital_status",
    "ethnicity",
  ];

  const customWidth = {
    patient_first_name: "80px",
    patient_last_name: "50px",
    national_id: "150px",
    sex: "50px",
  };

  const compareValue = [
    "national_id",
    "patient_first_name",
    "patient_middle_name",
    "education_level",
    "dob",
    "patient_last_name",
    "sex",
    "patient_region",
    "marital_status",
    "client_is_handicapped",
    "country_of_origin",
    "current_residential_address",
    "permanent_residential_address",
    "disability",
    "chiefdom",
    "postal_address",
    "secondary_cellphone",
    "primary_cellphone",
    "land_phone",
    "CMIS_id",
    "patient_code",
    "nurse_name",
    "nurse_id",
    "patient_email_id",
    "land_phone",
    "occupation",
    "marital_status",
  ];
  const customKeyName = {
    national_id: "National ID",
    patient_first_name: "First Name",
    patient_last_name: "Last Name",
    patient_middle_name: "Middle Name",
    dob: "Date of Birth",
    sex: "Sex",
    patient_region: "Region",
    marital_status: "Marital Status",
    client_is_handicapped: "Handicapped",
  };
  

  return (
    outlet || (
      <>
        <CustomDataTable
          tableTitle={"List of Patients"}
          endPoint={ENDPOINT.PATIENT}
          filterKey={"patient_first_name"}
          excludedKeys={excludedKeys}
          customWidth={customWidth}
          customKeyName={customKeyName}
          compareValue={compareValue}
        />
      </>
    )
  );
};
export default PatientList;
